import axios from "axios";
import { connect } from "react-redux";
import React, { useState, useEffect, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import DeployModal from "../DeployModal";
import EasyEdit, { Types } from "react-easy-edit";
import useAlertMessage from "../../hooks/useAlertMessage";
import { API_URL, API_V7_URL, DEFAULT_USER_IMG_URL, MAIN_WEBSITE_URL, SUBSCTYPE_ENTERPRISE } from "../../constants/Globals";
import { Col, Row, Tab, Tabs, Table, Form } from "react-bootstrap";
import { ClientJS } from "clientjs";
import ReactFlowCollectionBranches from "./collections/AddEditCollection";
import {
  addNewSequence,
  updateSequenceById,
  updateIsDraftById,
  getSequenceById,
} from "../../services/CollectionsSvc";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import DeployCollection from "./DeployCollection";
import SequenceSettings from "./SequenceSettings";
import SequenceAnalytics from "./SequenceAnalytics";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { buySubscriptionPlan, changeSubscriptionPlan, manageSubscriptionPlan } from "../../services/SubscriptionSvc";
import { handleSuccess } from "../../services/notifications";
import SubscriptionModal from "../SubscriptionModal";
import CopyEmailEmbedSequence from "../../helpers/CopyEmailEmbedSequence";

const client = new ClientJS();

const fingerprint = client.getFingerprint();

function NewCollection({ selNetworkId, match, networks }) {
  const [collectionName, setCollectionName] = useState("");
  const [embedCode, setEmbedCode] = useState("");
  const [isDraft, setIsDraft] = useState("");
  const [showDeployModal, setShowDeployModal] = useState(false);
  const [activeTab, setActiveTab] = useState("collection-details");
  const [setAlertMessage, getAlertMessage] = useAlertMessage();
  const { params } = match;

  const [currentDebateData, setCurrentDebateData] = useState({});
  const [dataTable, setDataTable] = useState({
    headers: [],
    rows: [],
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [gAMCode, setGAMCode] = useState("");
  const [groupId, setGroupId] = useState(0);
  const [isEnterprise, setIsEnterprise] = useState(false);
  const [isSubscriptionModalVisible, setIsSubscriptionModalVisible] = useState(false);
  const [subscriptionMetaDetails, setSubscriptionMetaDetails] = useState({});
  const [subscriptionTypeId, setSubscriptionTypeId] = useState(0);
  const [ loadingSubs, setLoadingSubs ] = useState(false);
  const [stepFirstDebateData, setStepFirstDebateData] = useState(null);
  const [sequenceLength, setSequenceLength] = useState(3);

  const sequenceSettingsRef = useRef(null);

  const handleSaveSequence = () => {
    if (sequenceSettingsRef.current) {
      sequenceSettingsRef.current();
    }
  };

  useEffect(() => {
    if (params?.id !== "new") {
      fetchCurrentDebate();
      getSequenceById(params.id).then(({ data }) => {
        const debateData = data.data;
        setStepFirstDebateData(debateData.steps[0]?.part || null);
        setSequenceLength(debateData.steps.length);
      });
    }
  }, [params.id]);

  const fetchCurrentDebate = async () => {
    await axios
      .get(
        API_URL +
          "/collections/" +
          params.id +
          "?deviceId=" +
          fingerprint +
          "&emailEmbedDebateLink=true"
      )
      .then((res) => {
        setCurrentDebateData(res.data.data);
      })
      .catch((err) => {
        alert("Failed. Please try again!");

        console.log(err);
      });
  };

  const history = useHistory();
  useEffect(() => {
    if (params.id === "new") {
      setEmbedCode("");
      setCollectionName("");
      setIsDraft(0);
      setGAMCode("");
    } else {
      axios.get(`${API_URL}/collections/${params.id}`).then(({ data }) => {
        const { name, isDraft } = data.data;
        setCollectionName(name);
        setIsDraft(isDraft);
      });
      setEmbedCode(
        `<div class="sided-widget" sequenceId="${params.id}"></div>`
      );
      setGAMCode(`<script>window.SidedIframeBurst=true;</script>
        <script src="https://embed-v2.sided.co/assets/sided-gam.js"></script>
        <div class="sided-widget" sequenceId="${params.id}"></div>`);
    }

  }, [params.id]);

  useEffect(() => {
    const getGroupSettingDetail = async () => {
      try {
        const res = await axios.get(`${API_URL}/admin/client/${selNetworkId}`);
        if (res.data.data.groups[0]?.id) {
          const groupId = res.data.data.groups[0].id;
          console.log('Got group ID as: ', groupId);
          setGroupId(groupId);

          const groupDtRes = await axios.get(
            `${API_V7_URL}/api/master/group-settings/group/${groupId}?includeRelations=true`
          );

          setIsEnterprise(
            groupDtRes.data.data?.subscription?.subscriptionTypeId === SUBSCTYPE_ENTERPRISE
          );
          setSubscriptionMetaDetails(
            groupDtRes.data.data.subscription?.metadata || {}
          );
          setSubscriptionTypeId(
            groupDtRes.data.data.subscription?.subscriptionTypeId || 0
          );
        }
      } catch (err) {
        console.log(err?.response?.data?.message || err);
      }
    };
    if (selNetworkId) {
      getGroupSettingDetail();
    }
    
  }, [selNetworkId]);

  const onManageSubscription = async () => {
      const response = await manageSubscriptionPlan(this.state.groupId);
      if (response.data.status === 1) {
        if (response.data.data?.url) {
          window.open(response.data.data.url, "_blank");
        }
      }
    };
  
    const onHandlePlan = async (planId, billingCycle) => {
      setLoadingSubs(true);
      try {
        const data = {
          subscriptionTypeId: planId,
          billingCycle: billingCycle,
          groupId: this.state.groupId,
        };
        let res;
        if (String(this.state.subscriptionTypeId) === "5") {
          res = await buySubscriptionPlan(data);
        } else {
          res = await changeSubscriptionPlan(this.state.groupId, data);
        }
        if (res.data.status === 1) {
          if (res.data.data?.url) {
            window.location.href = res.data.data.url;
          } else {
            handleSuccess("Plan upgraded successfully!");
            setTimeout(() => {
              window.location.reload();
            }, 1500);
          }
        }
      } catch (error) {
        console.error("Error upgrading subscription plan:", error);
        // setPaymentResult("failed");
      }
      setLoadingSubs(false);
    };

  const search = window.location.search;

  const fetchSequenceDetails = async (pageNumber = 1) => {
    try {
      setIsLoading(true); // Set loading state
      const response = await axios.get(
        `${API_V7_URL}/api/sequences/${params.id}/completions?pageNumber=${pageNumber}&pageSize=10`
      );

      const { headers, rows, totalUsers, perPage } = response.data.data;
      const totalPages = Math.ceil(totalUsers / perPage);

      setDataTable({
        headers,
        rows,
      });
      setTotalPages(totalPages);
      setCurrentPage(pageNumber);
    } catch (error) {
      console.error("Failed to fetch sequence completions:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (params.id !== "new") {
      fetchSequenceDetails();
    }
  }, [params.id]);

  const handlePageChange = (pageNumber) => {
    fetchSequenceDetails(pageNumber);
  };

  const onSaveName = async (value) => {
    try {
      const data = {
        clientId: selNetworkId,
        name: value,
      };
      const response =
        params.id === "new"
          ? await addNewSequence(data)
          : await updateSequenceById(params.id, data);
      if (response.data.status) {
        if (params.id === "new") {
          history.push(`/sequences/${response.data.data}`);
        }
      }
    } catch (error) {}
  };

  const onSaveIsDraft = async (value) => {
    try {
      console.log(value.nameInputVal);
      const data = {
        clientId: selNetworkId,
        isDraft: value.isDraftInputVal,
      };
      const response = await updateIsDraftById(params.id, data);
      if (response.data.status) {
        setIsDraft(value.isDraftInputVal);
      }
    } catch (error) {}
  };

  const action = new URLSearchParams(search).get("action");

  const exportCSV = () => {
    const csvContent =
      "data:text/csv;charset=utf-8," +
      [dataTable.headers.join(",")]
        .concat(
          dataTable.rows.map((row) =>
            dataTable.headers.map((header) => row[header] || "-").join(",")
          )
        )
        .join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "completions_data.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleCopyEmailEmbed = async () => {
    await CopyEmailEmbedSequence({
      stepFirstDebateData,
      sequenceLength,
      paramsId: params.id,
      setAlertMessage,
    });
  };

  return (
    <section>
      {getAlertMessage()}

      <div className="table-filters">
        <Link to="/sequences" className="text-button">
          <svg
            width="9"
            height="14"
            viewBox="0 0 9 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.56 11.8135L6.68 13.6668L0 7.00016L6.68 0.333496L8.56 2.18683L3.81333 7.00016L8.56 11.8135Z"
              fill="#2F80ED"
            />
          </svg>
          All Sequences
        </Link>
      </div>

      <h1 className="page-title d-flex justify-content-between align-items-center">
        {params.id === "new"
          ? "Add New Sequence"
          : `Edit Sequence: ${collectionName}`}
        {activeTab === "settings" && (
          <div>
            <button
              className="btn btn-secondary me-2"
              onClick={() => {
                alert("Settings canceled successfully!");
              }}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={() => {
                handleSaveSequence();
              }}
            >
              Save Sequence
            </button>
          </div>
        )}
      </h1>
      <Tabs
        defaultActiveKey={"collection-details"}
        activeKey={activeTab}
        id="uncontrolled-tab-example"
        className="mt-4 CreateDebateTabs pe-3 col-md-7 w-100"
        onSelect={(e) => setActiveTab(e)}
      >
        <Tab eventKey="collection-details" title="Sequence Details">
          <div className="segment-form after-tabs border-0">
            <div
              className="segment-form-body padding-s"
              style={{ paddingLeft: "0px" }}
            >
              {/* Row start of copy code and inactive button*/}
              <div className="d-flex flex-row justify-content-between align-items-start">
                {/* LEFT GROUP */}
                <div className="d-flex flex-row align-items-start gap-4">
                  {embedCode && (
                    <div className="segment-form-field mb-l">
                      <label className="type-2">Sequence Embed Code</label>
                      <span
                        className="customBtn btn btn-secondary p-2 ps-4 pe-4"
                        onClick={({ target }) => {
                          const textArea =
                            target.parentElement.querySelector("textarea");
                          textArea.select();
                          document.execCommand("copy");
                          setAlertMessage("Embed code copied to clipboard!");
                        }}
                      >
                        Copy Code
                      </span>
                      <span
                        className="p-2 ps-3 pe-3 ms-2"
                        onClick={() => {
                          window.open(
                            `${MAIN_WEBSITE_URL}/preview/${params.id}`,
                            "_blank",
                          );
                        }}
                        title="Preview Sequence"
                      >
                        <FontAwesomeIcon icon={faEye} />
                      </span>
                      <textarea
                        className="hiddenElement"
                        value={embedCode}
                        readOnly={true}
                      />
                    </div>
                  )}
                  {gAMCode && (
                    <div
                      className="segment-form-field mb-l"
                      style={{ opacity: !isEnterprise ? 0.7 : 1 }}
                    >
                      <label className="type-2">GAM Tag</label>
                      <span
                        className="customBtn btn btn-secondary p-2 ps-4 pe-4"
                        onClick={({ target }) => {
                          if (isEnterprise) {
                            const textArea =
                              target.parentElement.querySelector("textarea");
                            textArea.select();
                            document.execCommand("copy");
                            setAlertMessage("GAM tag copied to clipboard!");
                          } else {
                            console.log("Subscription modal opening...");
                            setIsSubscriptionModalVisible(true);
                          }
                        }}
                      >
                        Copy Code
                      </span>
                      <textarea
                        className="hiddenElement"
                        value={gAMCode}
                        readOnly={true}
                      />
                    </div>
                  )}
                  <div className="segment-form-field mb-l">
                    <label className="type-2">Email Embed</label>
                    <span
                      className="customBtn btn btn-secondary p-2 ps-4 pe-4"
                      onClick={handleCopyEmailEmbed}
                    >
                      Copy Email Embed
                    </span>
                  </div>
                </div>
                {/* RIGHT GROUP */}
                {params.id != "new" && (
                  <div className="d-flex flex-row align-items-center">
                    <Form>
                      <Form.Group controlId="authorVerified">
                        <Form.Check.Label
                          style={{
                            fontWeight: "bold",
                            fontSize: "14px",
                            marginTop: "5px",
                          }}
                        >
                          {!(isDraft == 1) ? "Active" : "Inactive"}
                        </Form.Check.Label>
                        <Form.Check.Input
                          className="toggle-checkbox"
                          value="1"
                          defaultChecked={false}
                          onChange={(e) =>
                            onSaveIsDraft({
                              isDraftInputVal: e.target.checked ? 0 : 1,
                            })
                          }
                          name="isDraft"
                          checked={isDraft == 0}
                        />
                      </Form.Group>
                    </Form>
                  </div>
                )}
              </div>
              {/* Row end of copy code and inactive button*/}
              <div className="segment-form-field mb-l">
                <label className="type-2">Sequence Name</label>
                <EasyEdit
                  type={Types.TEXT}
                  value={collectionName}
                  onSave={onSaveName}
                  saveButtonLabel={<FontAwesomeIcon icon={faCheck} />}
                  cancelButtonLabel={<FontAwesomeIcon icon={faTimes} />}
                  attributes={{ name: "collection-input", id: 1 }}
                />
              </div>

              {params.id !== "new" && activeTab === "collection-details" && (
                <ReactFlowCollectionBranches
                  sequenceId={params.id}
                  selNetworkId={selNetworkId}
                  networks={networks}
                />
              )}
            </div>
          </div>
        </Tab>
        <Tab
          disabled={params.id === "new"}
          eventKey="deploy-collection"
          title="Deploy Sequence"
        >
          {params.id !== "new" && (
            <Row id="publish-debate-section" className="">
              <Col md={7} className="pe-3">
                <span className="lightColorSpan">
                  Deploy this sequence to your website by selecting page(s)
                  below and clicking "Deploy to Selected" then selecting the
                  appropriate "Placement". You can also "Deploy to All Pages" or
                  "Deploy to Category".
                </span>
                {currentDebateData?.name && (
                  <DeployCollection
                    isQuestion="false"
                    id="deploy-debate"
                    section="collection"
                    clientIdFromParent={selNetworkId}
                    debateIdFromParent={params.id}
                    actionFromParent={action}
                    currentDebateData={currentDebateData}
                  />
                )}
              </Col>
            </Row>
          )}
        </Tab>
        <Tab
          disabled={params.id === "new"}
          eventKey="completions"
          title="Completions"
        >
          <div className="segment-form after-tabs border-0">
            <div
              className="segment-form-body padding-s"
              style={{ paddingLeft: "0px" }}
            >
              <button className="btn btn-secondary mb-3" onClick={exportCSV}>
                Export CSV
              </button>
              {isLoading ? (
                <p>Loading...</p>
              ) : (
                <div style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        {dataTable.headers &&
                          dataTable.headers.map((header, index) => (
                            <th key={index}>{header}</th>
                          ))}
                      </tr>
                    </thead>
                    <tbody>
                      {dataTable.rows && dataTable.rows.length > 0 ? (
                        dataTable.rows.map((row, rowIndex) => (
                          <tr key={rowIndex}>
                            {dataTable.headers.map((header, colIndex) => (
                              <td key={colIndex}>
                                {String(row[header] || "-")
                                  .split("\n")
                                  .map((line, i) => (
                                    <React.Fragment key={i}>
                                      {line}
                                      <br />
                                    </React.Fragment>
                                  ))}
                              </td>
                            ))}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan={dataTable.headers.length}
                            className="text-center"
                          >
                            No logged in entries yet
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              )}
              <div className="pagination mt-4">
                <button
                  className="btn btn-primary"
                  disabled={currentPage === 1}
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  Previous
                </button>
                <span className="mx-2">
                  Page {currentPage} of {totalPages}
                </span>
                <button
                  className="btn btn-primary"
                  disabled={currentPage === totalPages || totalPages === 0}
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </Tab>
        <Tab
          disabled={params.id === "new"}
          eventKey="settings"
          title="Settings"
        >
          {match.params.id !== "new" && (
            <SequenceSettings
              selNetworkId={selNetworkId}
              sequenceId={match.params.id}
              onSave={(handleSave) => {
                sequenceSettingsRef.current = handleSave;
              }}
            />
          )}
        </Tab>
        <Tab
          disabled={params.id === "new"}
          eventKey="sequence-analytics"
          title="Sequence Analytics"
        >
          {params.id !== "new" && (
            <SequenceAnalytics sequenceId={params.id} />
          )}
        </Tab>
      </Tabs>

      {showDeployModal ? (
        <DeployModal onClose={() => setShowDeployModal(false)} />
      ) : null}
      {isSubscriptionModalVisible && (
        <SubscriptionModal
          open={isSubscriptionModalVisible}
          billingType={subscriptionMetaDetails?.billingCycle}
          onOpenChange={() => setIsSubscriptionModalVisible(false)}
          currentPlan={subscriptionTypeId}
          onSelectPlan={(planId, billingCycle) =>
            onHandlePlan(planId, billingCycle)
          }
          onManageSubscription={onManageSubscription}
        />
      )}
    </section>
  );
}

const mapStateToProps = (state) => ({
  selNetworkId: state.networks.selNetworkId,
  networks: state.networks.networksList,
});

export default connect(mapStateToProps)(NewCollection);
